import { MenuRounded } from "@mui/icons-material";
import { Box } from "@mui/material";

import useAuth from "../../../config/context/authContext";
import useFirebase from "../../../config/context/firebaseContext";
import useMainState from "../../../config/context/mainStateContext";
import { BusProvider } from "./context";

import MainConfigBanner from "../../../components/MainConfigBanner";
import PageHeader from "../../../components/PageHeader";
import Departs from "./components/Departs";
import DeviceBanner from "./components/DeviceBanner";
import FavoriteStop from "./components/FavoriteStop";
import HolidayBanner from "./components/HolidayBanner";
import NewVersionBanner from "./components/NewVersionBanner";

export default function BusTab() {
  const { setShowSideMenuDrawer } = useMainState();
  const { currentUserState } = useAuth();
  const { getConfig } = useFirebase();

  return (
    <BusProvider>
      <Box>
        <PageHeader
          title="Circular"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
        />

        {getConfig("enabled_banner_update") && <NewVersionBanner />}

        <MainConfigBanner screen="bus" />

        {getConfig("enabled_favorite_stop") && <FavoriteStop />}

        {getConfig("enabled_departs") && (
          <>
            <HolidayBanner />
            <Departs />
          </>
        )}

        {"cordova" in window ? null : <DeviceBanner />}
      </Box>
    </BusProvider>
  );
}
